/**
 * Client-side mirror of backend/compliance.py::count_substantive_touches.
 *
 * DK's Two-Touch rule requires that at least 2 substantive user choices exist
 * on the portfolio before mass-generation. A "substantive" touch is one of:
 *   • lock: true
 *   • exclude: true
 *   • boost_pct: non-zero number
 *   • max_exposure_pct: any value
 *   • min_exposure_pct: any value
 *   • proj_override: any value (a real projection edit)
 *   • dual_threat: true (weekly rushing-QB Naked-Stack gate)
 *
 * This helper is imported by SundayAutoMode, PortfolioSplit, and the
 * TwoTouchGate — a single source of truth so the rule can't drift between
 * surfaces (which caused a real bug where PortfolioSplit was silently
 * ignoring `min_exposure_pct` and `proj_override` touches while
 * SundayAutoMode counted them).
 *
 * Keep in strict sync with backend/compliance.py.
 */
export const countSubstantiveTouches = (overrides) => {
  return Object.values(overrides || {}).reduce((n, v) => {
    if (!v || typeof v !== "object") return n;
    if (v.lock === true) n += 1;
    if (v.exclude === true) n += 1;
    if (v.boost_pct != null && Number(v.boost_pct) !== 0) n += 1;
    if (v.max_exposure_pct != null && v.max_exposure_pct !== "") n += 1;
    if (v.min_exposure_pct != null && v.min_exposure_pct !== "") n += 1;
    if (v.proj_override != null && v.proj_override !== "") n += 1;
    if (v.dual_threat === true) n += 1;
    if (v.cpt_lock === true) n += 1;
    if (v.cpt_exclude === true) n += 1;
    if (v.cpt_max_exposure_pct != null && v.cpt_max_exposure_pct !== "") n += 1;
    if (v.cpt_min_exposure_pct != null && v.cpt_min_exposure_pct !== "") n += 1;
    if (v.restore) n += 1;
    return n;
  }, 0);
};

export const MIN_TOUCHES = 2;
